export enum WizardSteps {
  ClientData = 1,
  Insurances = 3,
  Offer = 4,
  Payment = 6,
}
